
import {createSlice } from '@reduxjs/toolkit';

import axios from 'axios';

const initialState={
    notificationCount:0,
    user:null,
    token:null,
    name:null,
    notifications:[]
  
}






export const globalSlice=createSlice(
    {
        name:"data",
        initialState,
        reducers:{
            setNotificationCount:(state,action)=>{
                state.notificationCount=action.payload.count;
            },
            setLogin:(state,action)=>{
                state.token=action.payload.token;
                state.user=action.payload.user;
                state.name=action.payload.name;
                // state.roles=action.payload.roles;
            },
            setLogout:(state)=>{
                state.token=null;
                state.user=null;
                state.name=null;
                // state.roles=null;
               state.notifications=[]
            },
            setAddress:(state,action)=>{
                state.token=action.payload.details;
                state.Time=action.payload.Time
                // state.roles=action.payload.roles;
            },
            setNotifications:(state,action)=>{
                state.notifications=action.payload.notifications;
            },
            getNotifications:(state)=>{

            }
    
        },
       

    }
    
)


export const{setNotificationCount,setLogin,setLogout,setAddress,setNotifications}=globalSlice.actions;
// export const {setLogin,setLogout}=Global.actions;



export default globalSlice.reducer;